import * as R from "ramda";
import { getters } from "../model";

export const getAllRecordReferences = getters.recordReferences;

export const getAllRecordReferencesById = R.compose(
  R.prop("byId"),
  getters.recordReferences
);

export const getAllFieldReferencesById = R.compose(
  R.prop("byId"),
  getters.fieldReferences
);
